<template>
  <div>
    <div
      id="container"
      style="width: 760px;height: 500px"
    />
    <div id="panel" style="display: none"/>
  </div>
</template>

<script>
import AMap from "AMap"; // 引入高德地图AMap
import { mapState } from "vuex";
import "@/assets/css/navigation.css";
import { defaultLonLati } from "@/utils/basic";
import { getSCoordinate } from "./tools/tool";

export default {
  name: "GuideMap",
  emits: ["getLeftTime"],
  data() {
    return {
      currentCarPoint: [], // 当前急救车经纬度 || 最原始的位置,后面肯定是一直在变动的
      gpsData: {}, // gps的一系列数据
      destination: "", //  目标地址 经纬度
      targetLocation: "", // 目标地址 文字
      cycleTimer: null, // 循环计时器,更新地图图标位置
      firstMessage: true, // 第一次消息, 渲染导航
      lastTimeData: {}, // 上一次的数据
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      allPosition: "allPosition",
      currentList: "currentList",
      hospitalInfo: "hospitalInfo"

    }),
  },
  watch: {
    currentList: {
      handler(val) {
        const thisTimeData = JSON.stringify(val.find(item => {
          return item.ambulanceId === this.carID;
        }));
        if (thisTimeData === this.lastTimeData) {
          // 相等 什么事情也不干
        } else {
          // 清空导航, 甚至需要重绘 || 第一次的时候会走到这里...
          this.driving?.clear();
          this.firstMessage = true;
        }
        this.lastTimeData = thisTimeData;
      }
    },
    allPosition: {
      handler(val) {
        setTimeout(
          () => { // 必须要延迟一下, 不然, 刷新的时候, watch可能更快一点, 造成路径规划失败
            this.getMessage(val);
          }, 300
        );
      }
    }
  },
  mounted() {
    this.map = null; // 高德地图map对象
    this.driving = null;
    const { id } = this.$route.params;
    this.carID = id * 1;
    this.initMap();
  },
  beforeUnmount() {
    clearInterval(this.cycleTimer);
    this.cycleTimer = null;
    this.map?.destroy();
    this.map = null;
  },
  methods: {
    async getMessage(val) {
      try {
        let dataJson;
        try {
          dataJson = JSON.parse(val[this.carID]);
        } catch (e) {
          dataJson = val[this.carID];
        }
        if (!dataJson) return;
        this.gpsData = dataJson;
        this.currentCarPoint = [dataJson.longitude, dataJson.dimension];

        const current = this.currentList.find(item => {
          return item.ambulanceId === this.carID;
        });
        // 首先, 必须是第一次渲染, 有终点, 其次必须该车有任务
        const isShowDriving = this.firstMessage && current;
        if (isShowDriving) {
          const { statu, longitude, latitude } = current;
          const status = statu * 1;
          this.firstMessage = false;
          // const { targetLocation: hospitalAddress } = getSCoordinate(this.ambulanceLists, this.carID);
          if (status >= 3) { // 患者已经上车, 定位前往医院
            const { longitude, latitude } = this.hospitalInfo;
            this.destination = [longitude, latitude];
            // this.destination = await addressTolongLati(hospitalAddress, this.currentCarPoint);
          } else { // 患者未上车, 定位前往患者所在地
            this.destination = [longitude, latitude];
            // this.destination = await addressTolongLati(patientAddr, this.currentCarPoint);
          }
          this.beginDriving();
        }
      } catch (e) {
        return false;
      }
    },
    async initMap() {

      try {
        const { currentCarPoint } = await getSCoordinate(this.ambulanceLists, this.carID); // 此时已经把此急救车的经纬度存入data中  || 急救车目标地址也在这里获得了
        if (currentCarPoint.length) {
          this.currentCarPoint = currentCarPoint;
        } else {
          this.currentCarPoint = defaultLonLati;
        }
        this.map = new AMap.Map("container", {
          center: [...this.currentCarPoint],
          resizeEnable: true,
          viewMode: "2D", // 设置地图模式
          lang: "zh_cn", // 设置地图语言类型
          zoom: 13,
        });
        //  在地图上给一个急救车图标
        const ambulanceIcon = new AMap.Icon({
          size: new AMap.Size(50, 32),
          image: require("@/assets/photos/working.png"),
          imageSize: new AMap.Size(50, 32),
        });
        const ambulanceMarker = new AMap.Marker({
          position: new AMap.LngLat(...this.currentCarPoint),
          icon: ambulanceIcon,
          offset: new AMap.Pixel(0, 0),
        });
        if (this.currentCarPoint.length) {
          this.map?.add(ambulanceMarker);
        }

        this.cycleTimer = setInterval(() => {
          //  循环更新GPS定位
          if (this.currentCarPoint[0]) {
            ambulanceMarker.setPosition([...this.currentCarPoint]);
          }
        }, 1000);
      } catch (e) {
        console.log(e);

      }
    },
    beginDriving() {
      this.driving = new AMap.Driving({
        map: this.map,
        panel: "panel",
      });
      if (!this.currentCarPoint[0]) return; // 如果没有值的话, 就不规划路线了

      //  根据起终点经纬度规划驾车导航路线
      this.driving.search(
        new AMap.LngLat(...this.currentCarPoint),
        new AMap.LngLat(...this.destination),
        (status, result) => {
          if (status === "complete") {
            this.$emit("getLeftTime", result?.routes[0]?.time);
          } else {
            console.error("获取驾车数据失败：" + result);
          }
        }
      );
    }

  },
};
</script>
